module.exports = __webpack_public_path__ + "static/media/Dr. Sneha Tirpude.ee4819b9.png";